import { Outlet } from "react-router-dom";
// import Analytics from "../components/Analytics/Analytics";
import AdminSidebar from "../components/AdminDashboard/AdminSidebar";
import Header from "../components/AdminDashboard/Header";

const AdminLayout = () => {
    return (
        <div className="min-h-screen bg-gray-100 font-sans">
            <div className="flex">
                <AdminSidebar />
                <main className="flex-1 p-4 sm:p-6 lg:p-8">
                    <Header />
                    <div className="mt-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
